import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/system';

export const FinanceReportContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  width: '100%',
  backgroundColor: theme.palette.background.hover,
}));

export const ReportsFinanceTableContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  padding: theme.spacing(2),
  backgroundColor: theme.palette.background.default,
  borderRadius: '12px',
}));

export const TitleReport = styled(Typography)(({ theme }) => ({
  padding: theme.spacing(0, 1),
}));

export const ReportsFinanceContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  width: '100%',
  padding: theme.spacing(2),
  backgroundColor: theme.palette.background.paper,
}));
